export function ValueChainFigureNotes() {
  return <>All parts of the value chain, including internal, upstream and downstream impacts, are considered.</>;
}
